import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

function generateDynamicPathname(pathname, obj, includeSearch = true) {
  let resultPathname = pathname;

  Object.entries(obj).forEach(([key, value]) => {
    resultPathname = resultPathname.replace(`:${key}`, value);
  });
  if (includeSearch) {
    resultPathname = generatePathnameWithSearch(resultPathname);
  }
  return resultPathname;
}

function generatePathnameWithSearch(pathname, addedSearchParams, removedSearchParams) {
  let urlStringifyObject = '';
  let searchParams = history.location.search;

  if (addedSearchParams && typeof addedSearchParams === 'object') {
    urlStringifyObject = new URLSearchParams(addedSearchParams).toString();
  }

  if (urlStringifyObject) {
    searchParams = `${searchParams}${!searchParams ? '?' : '&'}${urlStringifyObject}`;
  }

  if (removedSearchParams) {
    searchParams = new URLSearchParams(searchParams);
    if (typeof removedSearchParams === 'string') {
      searchParams.delete(removedSearchParams);
    } else if (Array.isArray(removedSearchParams)) {
      removedSearchParams.forEach((removedSearchParam) => {
        searchParams.delete(removedSearchParam);
      });
    }
    if (searchParams.toString()) {
      searchParams = `?${searchParams}`;
    }
  }

  return `${pathname}${searchParams}`;
}

export { generateDynamicPathname, generatePathnameWithSearch };
export default history;
